module.exports = {"440304001":"南园街道","440304002":"园岭街道","440304004":"福田街道","440304005":"沙头街道","440304006":"香蜜湖街道","440304007":"梅林街道","440304008":"莲花街道","440304009":"华富街道","440304010":"福保街道","440304011":"华强北街道","440304400":"福田保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440304.json
// module id = 1796
// module chunks = 0